module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fixedHeader) ? _c('div', [_c('table', {
    staticClass: "mu-table"
  }, [_vm._t("header")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    style: (_vm.bodyStyle)
  }, [_c('table', {
    staticClass: "mu-table"
  }, [(!_vm.fixedHeader) ? _vm._t("header") : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (!_vm.fixedFooter) ? _vm._t("footer") : _vm._e()], 2)]), _vm._v(" "), (_vm.fixedFooter) ? _c('div', [_c('table', {
    staticClass: "mu-table"
  }, [_vm._t("footer")], 2)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13088327"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/table/table.vue
// module id = 419
// module chunks = 1